import Color from 'color'
import { createMuiTheme } from '@material-ui/core/styles'
import mesh from '../assets/mesh.svg'
import typography from './typography'

const colorPrimary = Color('#7B8DC7')
const colorSecondary = Color('#9DC7EA')
const colorTertiary = Color('#FFEAB7')

export const theme = {
  colors: {
    primary: colorPrimary.hex(),
    secondary: colorSecondary.hex(),
    tertiary: colorTertiary.hex(),
    background: '#fefefe',
  },
  space: [0, 4, 8, 16, 32, 48, 64, 128, 256],
  buttons: {
    mesh: {
      '&:before, &:after': {
        content: '""',
        position: 'absolute',
        opacity: 0,
        transition: 'opacity 400ms',
      },
      '&:before': {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: -2,
        background: `linear-gradient(45deg, ${colorPrimary.hex()} 30%, ${colorSecondary.hex()} 90%)`,
      },
      '&:after': {
        top: '-100%',
        right: '-100%',
        bottom: '-100%',
        left: '-100%',
        zIndex: -1,
        backgroundImage: `url(${mesh})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '133%',
      },
      '&:hover': {
        '&:before': {
          opacity: 1,
        },
        '&:after': {
          opacity: 0.133,
        },
        color: 'white',
      },
      position: 'relative',
      zIndex: 0,
      cursor: 'pointer',
      background: 'none',
      color: 'black',
      transition: 'color 400ms',
      overflow: 'hidden',
    },
  },
}

export const muiTheme = createMuiTheme({
  palette: {
    primary: {
      main: colorPrimary.hex(),
    },
    secondary: {
      main: colorSecondary.hex(),
    },
    tertiary: {
      main: colorTertiary.hex(),
    },
  },
  typography: {
    fontFamily: typography.options.bodyFontFamily.join(','),
  },
})

export default theme
